import urls from "global/constants/UrlConstants";
import { getCallParams, getNoAuthCallParams, makeCall } from "utils/service";

// AWS Marketplace setup. ss-core-service resolves the buyer's registration token at
// public/billing/aws-marketplace/register and redirects here with a one-time claim
// (see AwsMarketplaceRegistrationService in core). These two calls finish the job.

export interface AwsMarketplaceClaimInfo {
  status: "pending" | "invalid";
  app?: string;
  /** Last four digits of the buyer's AWS account, e.g. "********3333". */
  awsAccount?: string;
}

export interface AwsMarketplaceLinkResult {
  linked: boolean;
  billingSource: string;
  /**
   * Outcome of the first plan/seat sync: applied, unchanged, pending (AWS is still provisioning the contract; the
   * plan lands within minutes), expired (the subscription is no longer active, so no plan was applied and billing
   * stays with Inkfree) or failed.
   */
  plan?: string;
}

/** Public: whether the claim can still be used, before the buyer signs in. */
export const getAwsMarketplaceClaim = async (claim: string): Promise<AwsMarketplaceClaimInfo> => {
  try {
    const callParams = getNoAuthCallParams("POST", { claim });
    return await makeCall(urls.AWS_MARKETPLACE_CLAIM, callParams);
  } catch (error: any) {
    throw error;
  }
};

/**
 * Authenticated: links the claimed purchase to the signed-in account (admins only; core answers
 * 403 otherwise, 410 for a used/expired claim, 409 for an account that cannot take it).
 */
export const linkAwsMarketplaceClaim = async (claim: string): Promise<AwsMarketplaceLinkResult> => {
  try {
    const callParams = await getCallParams("POST", { claim });
    return await makeCall(urls.AWS_MARKETPLACE_LINK, callParams);
  } catch (error: any) {
    throw error;
  }
};
